<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { Core, DragDrop, StatusBar } from "uppy";
  import XHRUpload from "@uppy/xhr-upload";
  import { getLanguage } from "i18n/language.js";
  import ItalianLocale from "@uppy/locales/lib/it_IT";
  import EnglishLocale from "@uppy/locales/lib/en_US";

  export let lawcaseId;
  export let folderId;

  const dispatch = createEventDispatcher();

  const token = localStorage.getItem("client-token");

  onMount(() => {
    const uppy = new Core({
      debug: true,
      locale: $getLanguage == "it" ? ItalianLocale : EnglishLocale,
      autoProceed: true,
      meta: {
        lawcase_id: lawcaseId,
        folder_id: folderId,
      },
    });

    uppy
      .use(XHRUpload, {
        endpoint: "/upload-files/",
        metaFields: ["folder_id", "lawcase_id"],
        headers: { authorization: `Bearer ${token}` },
      })
      .use(DragDrop, {
        target: ".UppyDragAndDrop",
        width: "100%",
        height: "100%",
        note: null,
        locale: {},
      })
      .use(StatusBar, {
        target: ".UppyInput-Progress",
        hideUploadButton: false,
        hideAfterFinish: true,
      })
      .on("upload-success", (file, response) => {
        console.log(file, response);
        dispatch("success");
      })
      .on("upload-error", (file, error, response) => {
        console.log("error with file:", file);
        console.log("error message:", error);
        if (error.message.includes("upgrade_plan")) {
          uppy.cancelAll();
        }
        dispatch("fail", { error: error });
      });
  });
</script>

<div class="UppyDragAndDrop">
  <div class="UppyInput" />
  <div class="UppyInput-Progress" />
</div>
